if (!customElements.get('free-shipping')) {
  customElements.define(
    'free-shipping',
    class FreeShipping extends HTMLElement {
      constructor() {
        super();
        this.cartTotal = Number(this.dataset.cartTotal) || 0;
        this.freeShippingThreshold = Number(this.dataset.freeShippingThreshold) || 0;
        this.subscriptionFreeShipping = this.dataset.subscriptionFreeShipping;
        this.message = this.dataset.message || '';
        this.messageSomeAmmount = this.dataset.messageSomeAmmount || '';
        this.messageCompleted = this.dataset.messageCompleted || '';
        this.messageSubscription = this.dataset.messageSubscription || '';
        this.compiledMessage = '';
        this.currencySymbol = this.dataset.currencySymbol || '';
        this.roundAmount = this.dataset.roundAmount === 'true';
        this.observer = new MutationObserver(this.handleMutations.bind(this));
        this.progressBar = this.querySelector('progress-bar');
      }

      connectedCallback() {
        this.setMessage(this.getAmountLeft(this.cartTotal));
        this.addMessage();
        this.addEventListeners();
        this.observeAttributes();
        this.updateOtherFreeShippingElements();
      }

      disconnectedCallback() {
        this.removeEventListeners();
        this.observer.disconnect();
      }

      addEventListeners() {
        this.addEventListener('updateFreeShipping', this.updateFreeShipping.bind(this));
      }

      removeEventListeners() {
        this.removeEventListener('updateFreeShipping', this.updateFreeShipping.bind(this));
      }

      observeAttributes() {
        this.observer.observe(this, { attributes: true, attributeFilter: ['data-cart-total'] });
      }

      handleMutations(mutations) {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-total') {
            this.cartTotal = this.dataset.cartTotal;
            this.updateContent();
          }
        }
      }

      getAmountLeft(total) {
        const currencyRate = 1; // Shopify.currency.rate;
        let amountLeftToSpend = (this.freeShippingThreshold - (total * currencyRate)) / 100;
        amountLeftToSpend = Math.round(amountLeftToSpend * 100) / 100;
        amountLeftToSpend = this.roundAmount ? Math.round(amountLeftToSpend) : amountLeftToSpend;
        return amountLeftToSpend <= 0 ? 0 : this.currencySymbol + amountLeftToSpend;
      }

      setMessage(amountLeftToSpend) {
        if (this.cartTotal === 0) {
          this.compiledMessage = this.message;
        } else if (this.cartTotal >= this.freeShippingThreshold) {
          this.compiledMessage = this.messageCompleted;
        } else if (this.subscriptionFreeShipping === 'true') {
          this.compiledMessage = this.messageSubscription;
        } else {
          this.compiledMessage = this.messageSomeAmmount.replace('{{ amount }}', amountLeftToSpend);
        }
      }

      addMessage() {
        const node = document.createElement('p');
        node.innerHTML = this.compiledMessage;
        this.prepend(node);
      }

      updateContent() {
        if (this.subscriptionFreeShipping === 'true') {
          this.compiledMessage = this.messageCompleted;
          this.progressBar.setProgress(100); // Set progress bar to 100%
        } else {
          this.setMessage(this.getAmountLeft(this.cartTotal));
          this.progressBar.setProgress(this.barPercentage(this.cartTotal));
        }
        this.querySelector('p').innerHTML = this.compiledMessage;
      }

      barPercentage(cartTotal) {
        return ((cartTotal / this.freeShippingThreshold) * 100).toFixed(2);
      }

      updateFreeShipping(event = undefined) {
        if (event && event.detail && event.detail.cartTotal) {
          this.cartTotal = event.detail.cartTotal;
        } else {
          const totalsElement = document.querySelector('.cart__footer .totals__total-value');
          this.subscriptionFreeShipping = totalsElement.dataset.containsSubscription;
          this.cartTotal = Number(totalsElement.dataset.totalValue);
        }
        this.updateContent();
      }

      updateOtherFreeShippingElements() {
        const otherElements = document.querySelectorAll('free-shipping');
        otherElements.forEach(element => {
          if (element !== this) {
            element.setAttribute('data-cart-total', this.cartTotal);
          }
        });
      }
    }
  );
}

if (!customElements.get('progress-bar')) {
  customElements.define(
    'progress-bar',
    class ProgressBar extends HTMLElement {
    constructor() {
      super();

      this.progress = parseInt(this.dataset.value);
    }

    updateProgress() {
      this.style.setProperty('--progress', this.progress + '%');
    }

    setProgress(newProgress) {
      this.progress = Math.min(newProgress, 100); // Cap the progress at 100%
      this.updateProgress();
    }
  });
}
